
import log from "plugins/loglevel/index"

interface EventParams {
  category: string
  action: string
  options?: {
    eventLabel?: string
    eventValue?: number
  }
}

declare global {
  interface Window {
    dotq: undefined | any[] | {
      push: (el: any) => void,
    },
  }
}


// @see https://help.bingads.microsoft.com/#apex/3/en/help:app51208/-1/en-US
const track = ({category, action, options = {}}: EventParams) => {
  const {eventLabel, eventValue} = options
  const debug_message_fragments = [
    "[App.Tracking.YahooGemini.Event.track]",
    "about to track event with:",
    [
      `category: [${category}]`,
      `action: [${action}]`,
      `options: [${JSON.stringify(options)}]`,
    ].join(" ,"),
  ]

  log.debug(debug_message_fragments.join(" "))


  window.dotq = window.dotq || []

  window.dotq.push({
    ec: category ,
    ea: action,
    el: eventLabel,
    ev: eventValue,
  })
}

export default {track}
